import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isServer } from '@commons/utils';
import Backdrop from './components/Backdrop';
import Portal from './Portal';
import Container from './components/Container';

const ResponsiveModal = React.forwardRef(
  ({ children, open, blockScroll, onClose, ...props }, ref) => {
    if (isServer()) return null;

    const containerRef = useRef(null);
    const [showModal, setShowModal] = useState(open);

    // eslint-disable-next-line consistent-return
    useEffect(() => {
      if (open) {
        // Guarda el elemento activo antes de abrir el modal
        const { activeElement } = document;

        document.body.style.overflow = 'hidden';

        if (containerRef.current) {
          containerRef.current.focus();
        }

        // Agregar un evento para detectar la tecla Escape
        const handleKeyPress = event => {
          if (onClose && event.key === 'Escape') {
            onClose();
          }
        };

        // Agregar el evento al documento cuando el modal está abierto
        document.addEventListener('keydown', handleKeyPress);

        // Restaura el enfoque al elemento activo después de cerrar el modal

        return () => {
          document.removeEventListener('keydown', handleKeyPress);
          setShowModal(false);
          document.body.style.overflow = 'unset';
          activeElement.focus();
        };
      }
    }, [open, onClose]);

    return (
      <Portal
        open={showModal}
        ref={ref}
        role="dialog"
        aria-modal="true"
        {...props}
      >
        {open && (
          <Backdrop onClick={onClose}>
            <Container
              ref={containerRef}
              tabIndex={-1}
              onClick={e => e.stopPropagation()}
            >
              {children}
            </Container>
          </Backdrop>
        )}
      </Portal>
    );
  },
);

ResponsiveModal.displayName = 'ResponsiveModal';

ResponsiveModal.defaultProps = {
  blockScroll: true,
};

ResponsiveModal.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  blockScroll: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ResponsiveModal;
